import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestSummaryReport = get(
  'inventory.components.reports.guestSummary'
);

export const getGuestSummaryReportSearchQuery = createSelector(
  getGuestSummaryReport,
  get('searchQuery')
);
